import { datadogRum } from '@datadog/browser-rum';

const datadogRumManager = {
  /**
   * Setup Datadog rum default config with any custom overrides
   * @param overrides
   */
  init: (overrides = {}) => {
    if (!overrides.applicationId || !overrides.clientToken) {
      return;
    }
    datadogRum.init(
      Object.assign(
        {
          applicationId: '',
          clientToken: '',
          service: '',
          env: '',
          version: '',
          site: 'datadoghq.com',
          beforeSend: function (event) {
            datadogRumManager.cleanEvent(event);
          },
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          defaultPrivacyLevel: 'mask',
          trackResources: true,
          trackLongTasks: true,
        },
        overrides,
      ),
    );
    datadogRum.startSessionReplayRecording();
  },
  /**
   * Calls populates this with areas needed cleaning - params, url etc
   */
  cleaners: {
    params: [],
  },
  /**
   * Clean any sensitive info from requests before they're sent to Datadog
   */
  cleanEvent: (event) => {
    const cleaners = datadogRumManager.cleaners;
    const cleanString = function (string) {
      if (cleaners) {
        try {
          cleaners.params.length &&
            cleaners.params.forEach(function (s) {
              string = string.replace(
                new RegExp('(' + s + '=)[^&]+', 'ig'),
                '$1******',
              );
            });
        } catch (e) {
          string = 'error_sanitizing:' + e.toString();
        }
      }
      return string;
    };

    if (event?.resource?.url) {
      event.resource.url = cleanString(event.resource.url);
    }
    if (event?.error?.message) {
      event.error.message = cleanString(event.error.message);
    }
    if (event?.error?.stack) {
      event.error.stack = cleanString(event.error.stack);
    }
    if (event?.view?.url) {
      event.view.url = event.view.url.replace('/#', '');
    }
    return event;
  },
};

export default datadogRumManager;
